import React from 'react';
import {View} from 'react-native';

import BaseAvatar from '/component/base/Avatar';

import {styles} from './Avatar.style';
import {AvatarProps} from './Avatar.types';

export const Avatar = ({
  avatarUrl = '',
  avatarKey = '',
  fullName = '',
}: AvatarProps) => (
  <View style={styles.base}>
    <BaseAvatar
      size={50}
      avatarUrl={avatarUrl}
      avatarKey={avatarKey}
      isCoach={true}
      fullName={fullName}
    />
  </View>
);

export default Avatar;
